import React from "react";
import AllBlogs from "../components/all-blogs";

export default function AllBlogPage() {
  return <AllBlogs />;
}
